module.exports = __webpack_public_path__ + "img/title2_hover.0bd97383.png";